import React from 'react';
import { getMoodData } from '../../constants/moods';

function StatsCards({ totalEntries, thisWeek, topMood }) {
  const moodData = getMoodData(topMood || 'happy');

  return (
    <div className="dashboard__stats">
      <div className="dashboard__stat-card">
        <div className="dashboard__stat-icon dashboard__stat-icon--total">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
        </div>
        <div className="dashboard__stat-content">
          <div className="dashboard__stat-value">{totalEntries}</div>
          <div className="dashboard__stat-label">Total Entries</div>
        </div>
      </div>

      <div className="dashboard__stat-card">
        <div className="dashboard__stat-icon dashboard__stat-icon--week">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
        </div>
        <div className="dashboard__stat-content">
          <div className="dashboard__stat-value">{thisWeek}</div>
          <div className="dashboard__stat-label">This Week</div>
        </div>
      </div>

      <div className="dashboard__stat-card">
        <div className="dashboard__stat-icon dashboard__stat-icon--mood">
          {moodData.icon}
        </div>
        <div className="dashboard__stat-content">
          <div className="dashboard__stat-value">{moodData.label}</div>
          <div className="dashboard__stat-label">Top Mood</div>
        </div>
      </div>
    </div>
  );
}

export default StatsCards;
